module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_6.c2583326095e7313a8debd124e52d8da.png";